import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService } from 'src/app/services/alert.service';
// declare var $: any
@Component({
  selector: 'app-change-system-user-status',
  templateUrl: './change-system-user-status.component.html',
  styleUrls: ['./change-system-user-status.component.css']
})
export class ChangeSystemUserStatusComponent implements OnInit {

  is_edit: any;
  id: any;
  app_id: any;
  model: any = {};
  isprocessing: boolean = false;
  constructor(private checkPermissionService: CheckPermissionService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router) {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.app_id = this.activatedRoute.snapshot.params['app_id'];
  }

  ngOnInit() {
    this.getuserbyId();
    this.is_edit = this.checkPermissionService.getAction('edit');
    localStorage.setItem('option', 'setting');
  }
  
  getuserbyId() {
    this.authService.getuserbyId(this.id).subscribe((res) => {
      this.model = res;
      if (this.model.status + "" == "ACTIVATED") {
        this.model.status = true;
      }
      else {
        this.model.status = false;
      }
    }, error => {
      // console.log(error)
    },
      () => {

      })
  }
  updateUser() {
    this.isprocessing = true;
    if (this.model.status == true) {
      this.model.status = "ACTIVATED";
    }
    else {
      this.model.status = "DE-ACTIVATED";
    }
    this.authService.updateUser(this.model).subscribe((res) => {
      this.model = res
    }, error => {
      console.log(error)
    }, () => {
      this.alertService.updateAlert("User Updated Successfully");
      this.router.navigate(['/system-user-listing/' + this.app_id]);
    })
  }
}
